const typesSlideOverlay = {
	habits: 'habits',
	live: 'live',
	notification: 'notification',
	QR: 'q-r',
	programs: 'programs'
}

export default typesSlideOverlay
